/** @jsx jsx */
import { Box, jsx } from "theme-ui";
import React, { useEffect, useRef, useState } from "react";
import { PrimitiveProps } from "@styles/types";
import {
  BackgroundVideoStyles,
  VideoStyles,
  ContentWrapperStyles,
} from "./styles";
import LazyLoad from "react-lazyload";
import { motion } from "framer-motion";
import opacities from "@styles/design-tokens/07.opacities/opacities";
import transitions from "@styles/design-tokens/09.transitions/transitions";
import { millisToSeconds } from "@styles/utils/millisToSeconds";

export interface BackgroundVideoProps
  extends PrimitiveProps,
    React.ComponentPropsWithoutRef<"video"> {}

const BackgroundVideo: React.FC<BackgroundVideoProps> = ({
  sx,
  children,
  ...props
}) => {
  const boxRef = useRef<HTMLDivElement | null>(null);
  const [boxHeight, setBoxHeight] = useState(0);

  const [videoIsLoaded, setVideoIsLoaded] = useState(false);
  const handleSetVideo = () => {
    setVideoIsLoaded(true);
  };

  useEffect(() => {
    if (boxRef.current) {
      setBoxHeight(boxRef.current.offsetHeight);
    }
  }, []);

  return (
    <Box ref={boxRef} sx={{ ...BackgroundVideoStyles, ...sx }}>
      {boxHeight > 0 && (
        <LazyLoad height={boxHeight} once offset={-150}>
          <motion.div
            initial={{ opacity: opacities[0] }}
            animate={{ opacity: opacities[videoIsLoaded ? 100 : 0] }}
            transition={{
              duration: millisToSeconds(transitions.durations["300"]),
            }}
          >
            <video
              sx={{ ...VideoStyles }}
              {...props}
              autoPlay
              loop
              muted
              playsInline
              onLoadedData={handleSetVideo}
            >
              <source type="video/mp4" src={props.src} />
            </video>
          </motion.div>
        </LazyLoad>
      )}

      <Box sx={ContentWrapperStyles}>{children}</Box>
    </Box>
  );
};

BackgroundVideo.defaultProps = {};

export { BackgroundVideo };
